// extracted by mini-css-extract-plugin
export default {"button":"button--92485e","button_link":"button_link--e9a517","button__icon":"button__icon--ad96fd","button__text":"button__text--8de3b7"};